import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Sparkles, CheckCircle2, Clock } from "lucide-react";

const AUD = {
  partner: { label: "Partner", cls: "bg-sector-persona/15 text-[#A35F00]" },
  agenzia: { label: "Agenzia", cls: "bg-forest/10 text-forest" },
  tutti: { label: "Tutti", cls: "bg-terracotta/15 text-terracotta-hover" },
};
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "");

function AcksTable({ revision }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/admin/release-notes/${revision}/acks`).then(({ data }) => setRows(data)); }, [revision]);
  if (!rows) return <p className="text-sm text-muted-foreground">Caricamento…</p>;
  return (
    <div className="overflow-x-auto" data-testid={`acks-${revision}`}>
      <table className="w-full text-sm">
        <thead><tr className="text-left text-xs uppercase tracking-wide text-muted-foreground"><th className="py-2">Utente</th><th>Partner</th><th>Presa visione</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.user_id} className="border-t" data-testid={`ack-row-${r.email}`}>
              <td className="py-2"><div className="font-medium text-forest">{r.name || r.email}</div><div className="text-xs text-muted-foreground">{r.email}</div></td>
              <td className="text-muted-foreground">{r.partner || "Staff Agenzia"}</td>
              <td>{r.at ? <span className="flex items-center gap-1 text-terracotta"><CheckCircle2 className="h-4 w-4" />{fmt(r.at)}</span>
                : <span className="flex items-center gap-1 text-amber-700"><Clock className="h-4 w-4" />Non ancora</span>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function ReleaseNotesAdmin() {
  const [notes, setNotes] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/admin/release-notes").then(({ data }) => { setNotes(data); setOpen(data[0]?.revision); }); }, []);
  return (
    <div className="space-y-6" data-testid="release-notes-admin">
      <div>
        <h1 className="font-heading text-3xl font-semibold text-forest">Novità di versione</h1>
        <p className="mt-1 text-sm text-muted-foreground">Ogni voce ha il suo pubblico: le voci "Agenzia" le vede lo staff, le voci "Partner" i Partner con "Vede le novità" attivo (Partner › Dashboard), le voci "Tutti" entrambi. La finestra si chiude solo con "OK, ho preso visione".</p>
      </div>
      {notes.map((n) => (
        <Card key={n.revision} className="rounded-2xl p-5" data-testid={`release-${n.revision}`}>
          <button onClick={() => setOpen(open === n.revision ? null : n.revision)} className="flex w-full flex-wrap items-center justify-between gap-2 text-left">
            <div>
              <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-terracotta"><Sparkles className="h-4 w-4" />Aggiornamento n. {n.revision} · {n.date}</div>
              <div className="mt-1 font-heading text-lg font-semibold text-forest">{n.title}</div>
            </div>
            <span className="rounded-full bg-sage px-3 py-1 text-xs font-semibold text-forest" data-testid={`release-count-${n.revision}`}>{n.prese_visione} / {n.destinatari} prese visione</span>
          </button>
          {open === n.revision && (
            <div className="mt-4 space-y-4">
              <ul className="space-y-1.5 text-sm text-forest">{n.items.map((t, i) => (
                <li key={i} className="flex items-start gap-2" data-testid={`release-item-${n.revision}-${i}`}>
                  <span className={`mt-0.5 shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ${AUD[t.audience].cls}`}>{AUD[t.audience].label}</span>{t.text}
                  {t.link && <span className="ml-1 text-xs text-muted-foreground">→ {typeof t.link === "string" ? t.link : Object.entries(t.link).map(([k, v]) => `${k}: ${v}`).join(" · ")}</span>}
                </li>))}
              </ul>
              <AcksTable revision={n.revision} />
            </div>
          )}
        </Card>
      ))}
    </div>
  );
}
